import {Inline, Text, Viewport} from '@treatwell/ui';
import styles from './DayListNavigationBar.module.css';
import {NavButtonPrevious, NavButtonNext} from '../DayList/NavButton';
import {NavigateProps} from '../DayList/DayList';

type Props = {
  formattedMonth: string;
  selectedDate: string;
} & NavigateProps;

export const DayListNavigationBar = ({
  selectedDate,
  formattedMonth,
  onNavigateNext,
  onNavigatePrevious,
  isLastWeek,
  isFirstWeek,
  paginationFutureRequestStatus,
}: Props) => {
  const hideNavButtonNext =
    isLastWeek && !/pending|rejected/.test(paginationFutureRequestStatus);

  return (
    <div className={styles.root} data-cy="DayListNavigation">
      <Inline justify="between" align="center">
        <Text as="time" type="lgHeader" dateTime={selectedDate}>
          {formattedMonth}
        </Text>
        <Viewport device={['mobile', 'tablet']}>
          <Inline align="center" space="base">
            <NavButtonPrevious
              hide={isFirstWeek}
              onClick={(event) => {
                onNavigatePrevious?.();
                event.preventDefault();
              }}
            />
            <NavButtonNext
              hide={hideNavButtonNext}
              isLoading={paginationFutureRequestStatus === 'pending'}
              onClick={(event) => {
                if (paginationFutureRequestStatus !== 'pending') {
                  onNavigateNext?.();
                }
                event.preventDefault();
              }}
            />
          </Inline>
        </Viewport>
      </Inline>
    </div>
  );
};

export default DayListNavigationBar;
